import { renderToString } from "react-dom/server";

import { createImageIcon } from "@locators/components/shared/store-locator-icons";

import { PinEventIcon } from "@jti/brand-icons/pin-event";

export const DEFAULT_MARKER_LIGHT = createImageIcon(
  renderToString(<PinEventIcon width={30} height={30} fill={"#3a3d3f"} />)
);
export const DEFAULT_MARKER_DARK = createImageIcon(
  renderToString(<PinEventIcon width={30} height={30} fill={"#f5f5f5"} />)
);
export const ACTIVE_MARKER = createImageIcon(renderToString(<PinEventIcon width={38} height={38} fill="#3567FF" />));
